export enum CLIENT_CONSTANTS_PLACEHOLDERS {
  userFirstName = "%userFirstName%",
  assistantName = "%assistantName%",
  currentUserSubscriptionTier = "%currentSubscription%",
  subscriptionFree = "%subscriptionFree%",
  subscriptionTier1 = "%subscriptionTier1%",
  subscriptionTier2 = "%subscriptionTier2%",
  subscriptionTier3 = "%subscriptionTier3%",
}
